import * as service from "@/views/statement/services/index.js";

export default {
    state: {
        stmtList: [],
        total: 0,
        filter: {
            repository: null,
            type_id: "",
            keyword: "",
            page: 0,
            perpage: 10
        },
        processing: false
    },
    mutations: {
        updateStmtList(state, payload) {
            state.stmtList = payload.list || [];
            state.total = payload.count;
        },
        updateStmtListFilter(state, payload = {}) {
            state.filter = Object.assign({}, state.filter, payload);
        },
        updateProcessStatus(state, payload) {
            state.processing = payload;
        }
    },
    actions: {
        async queryStmtList(context, params) {
            params && context.commit("updateStmtListFilter", params);
            let filter = context.state.filter;

            let data = await service.getStatementList(filter);
            context.commit("updateStmtList", data);
        },
        addStmt({ dispatch }, params) {
            return service.addStatement(params).then(() => {
                dispatch("queryStmtList");
            });
        },
        updateStmt({ dispatch }, params) {
            return service.updateStatement(params).then(() => {
                dispatch("queryStmtList");
            });
        },
        deleteStmt({ dispatch }, params) {
            return service.deleteStatement(params).then(() => {
                dispatch("queryStmtList");
            });
        }
    }
};
